import { oz } from '@weft/utils';
import { ContactSchema } from './contact-schema';

export const ContactInputSchema = ContactSchema.extend({
  email: oz.string().email().optional(),
});

export type ContactInput = oz.infer<typeof ContactInputSchema>;